import { ProductPrice, useProductOptions } from "@shopify/hydrogen";

export function Price({ product }) {
    const { selectedVariant } = useProductOptions();
  
    return (
      <div className="flex gap-x-1 mt-10">
        <div className="text-custom-black text-lg font-semibold">MSRP :</div>
        <ProductPrice
          className="text-gray-500 line-through text-xl font-semibold"
          priceType="compareAt"
          variantId={selectedVariant?.id}
          data={product}
        />
        <ProductPrice
          className="text-custom-black text-lg font-semibold"
          variantId={selectedVariant?.id}
          data={product}
        />
      </div>
    );
  }
  